import type { CompareFeature } from './compare-plans-drawer.types';

export const COMPARE_FEATURES: CompareFeature[] = [
  {
    key: 'businessInfoCompleteness',
    descriptionKey: 'businessInfoDescription',
  },
  {
    key: 'productServicesDetection',
    descriptionKey: 'productServicesDescription',
  },
  {
    key: 'productEvaluation',
    descriptionKey: 'productEvaluationDescription',
  },
  {
    key: 'attributesCategoriesPricing',
    descriptionKey: 'attributesCategoriesDescription',
  },
  {
    key: 'competitorComparison',
    descriptionKey: 'competitorComparisonDescription',
  },
  {
    key: 'improvementCenter',
    descriptionKey: 'improvementCenterDescription',
  },
];
